import React from 'react';

import PurchaseDetailsSummary from './PurchaseDetails/summary';
import BillingDetailsSummary from './billingDetails/summary';

import './index.scss';

function DedicatedOrderSummary({ orderDetail }) {
  return (
    <section className="order_summary_form">
      <div className="row">
        <div className="flg-lg-12 flg-md-12">
          <React.Fragment>
            <PurchaseDetailsSummary orderDetail={orderDetail} />
            <BillingDetailsSummary orderDetail={orderDetail} />
          </React.Fragment>
        </div>
      </div>
    </section>
  );
}
export default DedicatedOrderSummary;
